(() => {
  angular
    .module('gm.common.filters')
    .filter('gmS3Img', gmS3ImgFilter);

  function gmS3ImgFilter(
    $log,
    gmAvatar
  ) {
    'ngInject';

    const SIZES = [30, 128, 256, 512, 'orig'];

    const btgAvatarFilter = (url, size) => {
      if (SIZES.indexOf(size) === -1) {
        $log.error('Wrong file size! Available sizes:', SIZES);
      }
      return url ? `${url}${size}?t=${gmAvatar.getAvatarTimestamp()}` :
        '/img/avatar-default.svg';
    };

    btgAvatarFilter.$stateful = true;

    return btgAvatarFilter;
  }
})();
